export const myConnectList = [
  { id: 1, name: 'Samsung Health', connection: 1 },
  { id: 2, name: 'Google Fit', connection: 0 },
  { id: 3, name: 'Fitbit', connection: 0 },
  { id: 4, name: 'Polar', connection: 0 },
  { id: 5, name: 'Misfit', connection: 0 },
  { id: 6, name: 'Garmin', connection: 0 },
  { id: 7, name: '파트론 밴드(250/400)', connection: 0 },
  { id: 8, name: '파트론 워치(250/400)', connection: 0 },
  { id: 9, name: '인바디 스마트 밴드 1/2', connection: 1 },
  { id: 10, name: '플레이핏', connection: 1 },
  { id: 11, name: '코아핏', connection: 1 },
  { id: 12, name: '세븐일렉', connection: 1 },
];

export const myInquiryList = [
  {
    id: 1,
    type: 2,
    answerType: 1,
    createDate: '2024.07.10',
    answerDate: '2024.07.12',
    name: '스탬프 투어 신청이 안돼요. 스탬프 투어 신청이 안돼요.',
    con: `스탬프 투어 신청이 안돼요.`,
    img: [`imgArea`, `imgArea`, `imgArea`],
    answer: `불편을 끼쳐드려 죄송합니다. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, Bibendum quis purus eu, ullamcorper malesuada quam.\n불편을 끼쳐드려 죄송합니다. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, Bibendum quis purus eu, ullamcorper malesuada quam.\n불편을 끼쳐드려 죄송합니다. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, Bibendum quis purus eu, ullamcorper malesuada quam.불편을 끼쳐드려 죄송합니다. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, Bibendum quis purus eu, ullamcorper malesuada quam.\n불편을 끼쳐드려 죄송합니다. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, Bibendum quis purus eu, ullamcorper malesuada quam.\n불편을 끼쳐드려 죄송합니다. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, Bibendum quis purus eu, ullamcorper malesuada quam.불편을 끼쳐드려 죄송합니다. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, Bibendum quis purus eu, ullamcorper malesuada quam.\n불편을 끼쳐드려 죄송합니다. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, Bibendum quis purus eu, ullamcorper malesuada quam.\n불편을 끼쳐드려 죄송합니다. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, Bibendum quis purus eu, ullamcorper malesuada quam.불편을 끼쳐드려 죄송합니다. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, Bibendum quis purus eu, ullamcorper malesuada quam.\n불편을 끼쳐드려 죄송합니다. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, Bibendum quis purus eu, ullamcorper malesuada quam.\n불편을 끼쳐드려 죄송합니다. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, Bibendum quis purus eu, ullamcorper malesuada quam.`,
  },
  {
    id: 2,
    type: 3,
    answerType: 0,
    createDate: '2024.07.10',
    answerDate: '',
    name: '어플이 자꾸 멈춰요.',
    con: `어플이 자꾸 멈춰요.`,
    img: [`imgArea`, `imgArea`],
    answer: ``,
  },
  {
    id: 3,
    type: 1,
    answerType: 0,
    createDate: '2024.07.10',
    answerDate: '',
    name: '포인트 보상이 궁급합니다.',
    answer: ``,
  },
  {
    id: 4,
    type: 2,
    answerType: 1,
    createDate: '2024.07.10',
    answerDate: '2024.07.12',
    name: '스탬프 투어 신청이 안돼요.',
    con: `스탬프 투어 신청이 안돼요.`,
    answer: `불편을 끼쳐드려 죄송합니다. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, Bibendum quis purus eu, ullamcorper malesuada quam.\n불편을 끼쳐드려 죄송합니다. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, Bibendum quis purus eu, ullamcorper malesuada quam.\n불편을 끼쳐드려 죄송합니다. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, Bibendum quis purus eu, ullamcorper malesuada quam.`,
  },
  {
    id: 5,
    type: 3,
    answerType: 1,
    createDate: '2024.07.10',
    answerDate: '2024.07.12',
    name: '어플이 자꾸 멈춰요.',
    answer: `불편을 끼쳐드려 죄송합니다. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, Bibendum quis purus eu, ullamcorper malesuada quam.\n불편을 끼쳐드려 죄송합니다. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, Bibendum quis purus eu, ullamcorper malesuada quam.\n불편을 끼쳐드려 죄송합니다. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, Bibendum quis purus eu, ullamcorper malesuada quam.`,
  },
  {
    id: 6,
    type: 1,
    answerType: 0,
    createDate: '2024.07.10',
    answerDate: '',
    name: '포인트 보상이 궁급합니다.',
    answer: ``,
  },
  {
    id: 7,
    type: 2,
    answerType: 1,
    createDate: '2024.07.10',
    answerDate: '2024.07.12',
    name: '스탬프 투어 신청이 안돼요. 스탬프 투어 신청이 안돼요.',
    answer: ``,
  },
  {
    id: 8,
    type: 3,
    answerType: 0,
    createDate: '2024.07.10',
    answerDate: '',
    name: '어플이 자꾸 멈춰요.',
    answer: ``,
  },
  {
    id: 9,
    type: 1,
    answerType: 0,
    createDate: '2024.07.10',
    answerDate: '',
    name: '포인트 보상이 궁급합니다.',
    answer: ``,
  },
  {
    id: 10,
    type: 2,
    answerType: 1,
    createDate: '2024.07.10',
    answerDate: '2024.07.12',
    name: '스탬프 투어 신청이 안돼요.',
    answer: ``,
  },
  {
    id: 11,
    type: 3,
    answerType: 1,
    createDate: '2024.07.10',
    answerDate: '2024.07.12',
    name: '어플이 자꾸 멈춰요.',
    answer: `불편을 끼쳐드려 죄송합니다. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, Bibendum quis purus eu, ullamcorper malesuada quam.\n불편을 끼쳐드려 죄송합니다. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, Bibendum quis purus eu, ullamcorper malesuada quam.\n불편을 끼쳐드려 죄송합니다. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, Bibendum quis purus eu, ullamcorper malesuada quam.`,
  },
  {
    id: 12,
    type: 1,
    answerType: 0,
    answerDate: '',
    name: '포인트 보상이 궁급합니다.',
    answer: ``,
  },
];

export const myNoticeList = [
  {
    id: 1,
    name: '앱 업데이트 - 버전 2.0',
    createDate: '2024.07.10',
    con: `새로운 기능과 성능 향상을 포함한 버전 2.0이 출시되었습니다. 이번 업데이트에서는 다음과 같은 변화가 있습니다.\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, bibendum quis purus eu, ullamcorper malesuada quam.\nNam vitae tellus lectus. Sed porttitor nec massa eu faucibus. Maecenas at justo nisi. Fusce eget turpis lorem.`,
    img: 'sample',
  },
  {
    id: 2,
    name: '앱 업데이트 - 버전 2.0',
    createDate: '2024.07.10',
    con: `새로운 기능과 성능 향상을 포함한 버전 2.0이 출시되었습니다. 이번 업데이트에서는 다음과 같은 변화가 있습니다.\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, bibendum quis purus eu, ullamcorper malesuada quam.\nNam vitae tellus lectus. Sed porttitor nec massa eu faucibus. Maecenas at justo nisi. Fusce eget turpis lorem.`,
    img: 'sample',
  },
  {
    id: 3,
    name: '앱 업데이트 - 버전 2.0',
    createDate: '2024.07.10',
    con: `새로운 기능과 성능 향상을 포함한 버전 2.0이 출시되었습니다. 이번 업데이트에서는 다음과 같은 변화가 있습니다.\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, bibendum quis purus eu, ullamcorper malesuada quam.\nNam vitae tellus lectus. Sed porttitor nec massa eu faucibus. Maecenas at justo nisi. Fusce eget turpis lorem.`,
    img: 'sample',
  },
  {
    id: 4,
    name: '앱 업데이트 - 버전 2.0',
    createDate: '2024.07.10',
    con: `새로운 기능과 성능 향상을 포함한 버전 2.0이 출시되었습니다. 이번 업데이트에서는 다음과 같은 변화가 있습니다.\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, bibendum quis purus eu, ullamcorper malesuada quam.\nNam vitae tellus lectus. Sed porttitor nec massa eu faucibus. Maecenas at justo nisi. Fusce eget turpis lorem.`,
    img: 'sample',
  },
  {
    id: 5,
    name: '앱 업데이트 - 버전 2.0',
    createDate: '2024.07.10',
    con: `새로운 기능과 성능 향상을 포함한 버전 2.0이 출시되었습니다. 이번 업데이트에서는 다음과 같은 변화가 있습니다.\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, bibendum quis purus eu, ullamcorper malesuada quam.\nNam vitae tellus lectus. Sed porttitor nec massa eu faucibus. Maecenas at justo nisi. Fusce eget turpis lorem.`,
    img: 'sample',
  },
  {
    id: 6,
    name: '앱 업데이트 - 버전 2.0',
    createDate: '2024.07.10',
    con: `새로운 기능과 성능 향상을 포함한 버전 2.0이 출시되었습니다. 이번 업데이트에서는 다음과 같은 변화가 있습니다.\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, bibendum quis purus eu, ullamcorper malesuada quam.\nNam vitae tellus lectus. Sed porttitor nec massa eu faucibus. Maecenas at justo nisi. Fusce eget turpis lorem.`,
    img: 'sample',
  },
  {
    id: 7,
    name: '앱 업데이트 - 버전 2.0',
    createDate: '2024.07.10',
    con: `새로운 기능과 성능 향상을 포함한 버전 2.0이 출시되었습니다. 이번 업데이트에서는 다음과 같은 변화가 있습니다.\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, bibendum quis purus eu, ullamcorper malesuada quam.\nNam vitae tellus lectus. Sed porttitor nec massa eu faucibus. Maecenas at justo nisi. Fusce eget turpis lorem.`,
    img: 'sample',
  },
  {
    id: 8,
    name: '앱 업데이트 - 버전 2.0',
    createDate: '2024.07.10',
    con: `새로운 기능과 성능 향상을 포함한 버전 2.0이 출시되었습니다. 이번 업데이트에서는 다음과 같은 변화가 있습니다.\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, bibendum quis purus eu, ullamcorper malesuada quam.\nNam vitae tellus lectus. Sed porttitor nec massa eu faucibus. Maecenas at justo nisi. Fusce eget turpis lorem.`,
    img: 'sample',
  },
  {
    id: 9,
    name: '앱 업데이트 - 버전 2.0',
    createDate: '2024.07.10',
    con: `새로운 기능과 성능 향상을 포함한 버전 2.0이 출시되었습니다. 이번 업데이트에서는 다음과 같은 변화가 있습니다.\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, bibendum quis purus eu, ullamcorper malesuada quam.\nNam vitae tellus lectus. Sed porttitor nec massa eu faucibus. Maecenas at justo nisi. Fusce eget turpis lorem.`,
    img: 'sample',
  },
  {
    id: 10,
    name: '앱 업데이트 - 버전 2.0',
    createDate: '2024.07.10',
    con: `새로운 기능과 성능 향상을 포함한 버전 2.0이 출시되었습니다. 이번 업데이트에서는 다음과 같은 변화가 있습니다.\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, bibendum quis purus eu, ullamcorper malesuada quam.\nNam vitae tellus lectus. Sed porttitor nec massa eu faucibus. Maecenas at justo nisi. Fusce eget turpis lorem.`,
    img: 'sample',
  },
  {
    id: 11,
    name: '앱 업데이트 - 버전 2.0',
    createDate: '2024.07.10',
    con: `새로운 기능과 성능 향상을 포함한 버전 2.0이 출시되었습니다. 이번 업데이트에서는 다음과 같은 변화가 있습니다.\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, bibendum quis purus eu, ullamcorper malesuada quam.\nNam vitae tellus lectus. Sed porttitor nec massa eu faucibus. Maecenas at justo nisi. Fusce eget turpis lorem.`,
    img: 'sample',
  },
];
